import RpcClass from "../../../../server/RpcClass.js";


import RpcNotFoundException from "../../../../server/com/silkplm/engine/rpc/exceptions/RpcNotFoundException.js";

let locale;
if(typeof window !== "undefined") {
    locale = window?.navigator?.userLanguage || window?.navigator?.language || Intl.DateTimeFormat().resolvedOptions().locale;
} else {
    locale= RpcClass.locale = Intl.DateTimeFormat().resolvedOptions().locale;
}

const FULL_CLASS = 'com.silkplm.rpc.Admin';

import LocalDate from "../../../../server/LocalDate.js";
import LocalDateTime from "../../../../server/LocalDateTime.js";
import LocalTime from "../../../../server/LocalTime.js";



class Admin extends RpcClass{

    /**
     *  @class Admin
     *  @alias module:src/server/com/silkplm/rpc/Admin.Admin
     *  
     * */
    constructor(){
        super();


    }






    /** 
     * @async
     * @param login {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/RpcMustWaitException.RpcMustWaitException}
     * @returns {Promise<string>}
     */
     admEcho(login) {
            return RpcClass.rpcCall('/rpc/admin/adm-echo', [login]);
    }
    /** 
     * @async
     * @param actionFindReportId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/model/ActionFindReport.ActionFindReport>}
     */
     getActionFindReportInfo(actionFindReportId) {
            return RpcClass.rpcCall('/rpc/admin/get-action-find-report-info', [actionFindReportId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/OrganizationDataInfo.OrganizationDataInfo[]>}
     */
     getAllOrganizationsDataInfo() {
            return RpcClass.rpcCall('/rpc/admin/get-all-organizations-data-info', []);
    }
    /** 
     * @async
     * @param fromDate {string} 
     * @param toDate {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/engine/model/ActionFindReport.ActionFindReport[]>}
     */
     getAllSmartSearchResults(fromDate, toDate) {
            return RpcClass.rpcCall('/rpc/admin/get-all-smart-search-results', [fromDate, toDate]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<Object.<string, *>>}
     */
     getMetrics() {
            return RpcClass.rpcCall('/rpc/admin/get-metrics', []);
    }
    /** 
     * @async
     * @param organizationId {string} 
     * @param count {number} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/OrganizationDataInfo.OrganizationDataInfo>}
     */
     getOneOrganizationDataInfo(organizationId, count) {
            return RpcClass.rpcCall('/rpc/admin/get-one-organization-data-info', [organizationId, count]);
    }
    /** 
     * @async
     * @param organizationId {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Organization.Organization>}
     */
     getOrganizationById(organizationId) {
            return RpcClass.rpcCall('/rpc/admin/get-organization-by-id', [organizationId]);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<module:src/server/com/silkplm/model/users/Organization.Organization[]>}
     */
     listOrganizations() {
            return RpcClass.rpcCall('/rpc/admin/list-organizations', []);
    }
    /** 
     * @async
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     refreshCerts() {
            return RpcClass.rpcCall('/rpc/admin/refresh-certs', []);
    }
    /** 
     * @async
     * @param copyFrom {string} 
     * @param clonedOrg {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @returns {Promise<string>}
     */
     setupClone(copyFrom, clonedOrg) {
            return RpcClass.rpcCall('/rpc/admin/setup-clone', [copyFrom, clonedOrg]);
    }
    /** 
     * @async
     * @param login {string} 
     * @param password {string} 
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInputValidationException.RpcInputValidationException}
     * @throws {module:src/server/com/silkplm/engine/rpc/exceptions/RpcInternalException.RpcInternalException}
     * @throws {module:src/server/com/silkplm/rpc/RpcMustWaitException.RpcMustWaitException}
     * @returns {Promise<module:src/server/com/silkplm/rpc/dto/UserInfo.UserInfo>}
     */
     signIn(login, password) {
            return RpcClass.rpcCallFixed('/rpc/admin/sign-in', [login, password]);
    }


    /** @returns {string} */
    getRemoteClass(){
        return FULL_CLASS;
    }
}



let metadata = {};

metadata.__type__ = 'com.silkplm.rpc.Admin';
metadata.__type_short__ = 'Admin';
Admin.prototype.__metadata__ = metadata;

Admin.prototype.__cls__ = FULL_CLASS;

/** @module src/server/com/silkplm/rpc/Admin */
export default Admin

export { Admin }
